module.exports = __webpack_public_path__ + "img/cross_icon.a2ef16ec.svg";